<template>
  <div id="rating-2019-modal">
    <modal v-model="show"
           size="lg"
           :backdrop="false">
      <template slot="header">
        <h2>Évaluation SPIADI 2019</h2>
      </template>
      <div class="text-justify rating-alerts">
        <alert type="info">
          <p>
            Afin d'évaluer votre degré de satisfaction concernant les
            différents aspects de la surveillance et de définir les axes
            d'amélioration pour l'année 2020, nous vous prions de bien vouloir
            remplir le questionnaire ci-dessous.
          </p>
          <p>
            <strong>
              Cette évaluation concerne la phase de recueil et de saisie
              uniquement.
            </strong> Un autre questionnaire vous sera envoyé concernant
            les résultats et leur valorisation.
          </p>
        </alert>
        <alert type="warning">
          <p>
            <strong>
              Merci de noter chaque proposition entre 1 et 10 en cliquant sur
              l'étoile correspondante ou d'indiquer «non concerné».
            </strong>
          </p>
        </alert>
      </div>
      <hr />
      <div class="row">
        <div v-for="r in sc.questions"
             class="col-sm-10 col-sm-offset-1 col-md-offset-0 col-md-6 text-center"
             :key="r.key">
          <div class="survey-question" :class="`survey-question-${r.style}`">
            <p><strong>{{ r.title }}</strong></p>
            <p><small v-if="r.subtitle">({{ r.subtitle }})</small></p>
            <star-rating v-model="ratings[r.key]"
                         :border-width="sc.star.border.width"
                         :border-color="sc.star.border.color"
                         :max-rating="10"
                         inline
                         @rating-selected="resetNA(r.key)"
                         class="rating"
                         :read-only="waiting"
                         :glow="sc.star.glow"
                         :show-rating="false"
                         :star-size="sc.star.size"
                         :star-points="sc.star.points">
            </star-rating>
            <btn class="question-reset"
                 size="xs"
                 v-if="!r.mandatory"
                 :disabled="waiting"
                 :active="na[r.key]"
                 @click="toggleRatingLock(r.key)">
              Non concerné
            </btn>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="text-center col-xs-12">
          <div class="survey-question">
            <h4>
              <strong>
                Satisfaction globale pour la phase de surveillance 2019
              </strong>
            </h4>
            <star-rating @rating-selected="resetNA('overall')"
                         v-model="ratings.overall"
                         :border-width="sc.star.border.width"
                         :border-color="sc.star.border.color"
                         :max-rating="10"
                         inline
                         class="rating"
                         :read-only="waiting"
                         :glow="sc.star.glow"
                         :show-rating="false"
                         :star-size="sc.star.big"
                         :star-points="sc.star.points">
            </star-rating>
          </div>
        </div>
      </div>
      <hr />
      <div class="form-group">
        <h3 for="comment" class="control-label">
          Commentaires concernant la surveillance 2019
        </h3>
        <textarea required
                  id="comment"
                  class="form-control"
                  rows="6"
                  maxlength="1000"
                  :disabled="waiting"
                  v-model.trim="comment"
                  placeholder="Message..."/>
      </div>
      <div class="form-group">
        <h3 for="evolution" class="control-label">
          Évolutions souhaitées pour 2020
        </h3>
        <textarea required
                  id="evolution"
                  class="form-control"
                  rows="6"
                  maxlength="1000"
                  :disabled="waiting"
                  v-model.trim="evolution"
                  placeholder="Message..."/>
      </div>
      <hr />
      <collapse v-model="error.error">
        <sui-error-panel :error="error">
        </sui-error-panel>
      </collapse>
      <template slot="footer">
        <btn type="danger" size="lg" @click="$emit('input', false)">
          Répondre au sondage plus tard
        </btn>
        <btn type="success"
             size="lg"
             :disabled="waiting"
             @click="send">
          Envoyer mon évaluation
        </btn>
      </template>
    </modal>
  </div>
</template>
<script>
import sc from '@/components/establishments/list/sc/rating'

import suiErrorPanel from '@/sui/components/errorpanel'
import Error from '@/sui/tools/error'

import rating from 'vue-star-rating'

export default {
  name: 'rating-2019-modal',

  props: {
    value: {
      type: Boolean,
      required: true
    }
  },

  data: function () {
    const na = {}
    const ratings = {}
    sc.keys.forEach(
      k => {
        na[k] = false
        ratings[k] = 0
      }
    )

    return {
      waiting: false,
      show: this.value,
      sc: sc,
      ratings: ratings,
      na: na,
      comment: '',
      evolution: '',
      error: new Error()
    }
  },

  watch: {
    value: function () {
      this.show = this.value
    }
  },

  methods: {
    resetNA: function (key) {
      this.na[key] = false
      this.error.show = false
    },

    toggleRatingLock: function (key) {
      if (this.na[key]) {
        this.na[key] = false
      } else {
        this.na[key] = true
        this.ratings[key] = 0
      }
      this.error.show = false
    },

    setError: function (title, body, contact) {
      this.error.set('Attention !', title, body, contact)
    },

    resetError: function () {
      this.error.reset()
    },

    send: function () {
      this.waiting = true
      this.resetError()
      if (!this.checkFields()) {
        this.waiting = false
        return
      }
      const request = {
        t: 'surveillance2019',
        c: [
          {
            k: 'comment',
            v: btoa(encodeURIComponent(this.comment))
          },
          {
            k: 'evolution',
            v: btoa(encodeURIComponent(this.evolution))
          }
        ],
        r: []
      }
      for (let r in this.ratings) {
        const v = this.ratings[r]
        if (v == null || v === 0) {
          continue
        }
        request.r.push({
          k: r,
          v: v
        })
      }
      const vm = this
      this.$store.dispatch('user/answerSurvey', request).then(
        (response) => {
          if (response.data.err != null) {
            vm.waiting = false
            vm.setError(
              `Erreur lors de l'enregistrement du formulaire`,
              `Merci de vérifier votre connexion internet avant de réessayer.`
            )
          } else {
            vm.$notify(
              {
                type: 'success',
                title: 'Évaluation reçue !',
                content: `Merci d'avoir participé au sondage.`,
                duration: 4000
              }
            )
            vm.$emit('input', false)
          }
        }
      ).catch(() => {
        vm.setError(
          `Erreur lors de l'enregistrement du formulaire`,
          `Merci de vérifier votre connexion internet avant de réessayer.`
        )
        vm.waiting = false
      })
    },

    checkFields: function () {
      if (!this.ratings.overall) {
        this.setError(
          'Notation manquante : satisfaction globale',
          'Merci de bien vouloir indiquer votre satisfaction globale.',
          false
        )
        return false
      }

      for (let i in sc.questions) {
        const key = sc.questions[i].key
        const valid = this.ratings[key] > 0 || this.na[key]
        if (!valid) {
          this.setError(
            'Notation.s manquante.s',
            `Merci de bien vouloir remplir toutes les notations en indiquant le
nombre d'étoiles ou «non concerné».`,
            false
          )
          return false
        }
      }
      return true
    }
  },

  components: {
    'star-rating': rating,
    'sui-error-panel': suiErrorPanel
  }
}
</script>
<style lang="less" scoped>
@import "~variables";

.survey-question {
  padding: 2rem 5rem;
  border-radius: 8px;
  border: 2px solid @dark-base;
  background-color: lighten(@dark-base, 55%);
  color: @darker-base;

  .btn {
    border-color: @dark-base;
    color: @darker-base;
  }

  .btn:hover {
    background-color: @dark-base;
    color: white;
  }

  .btn.active {
    background-color: @dark-base;
    color: white;
  }

  .btn.disabled {
    opacity: 1;
  }

  p {
    margin-bottom: 0px;
    font-size: 110%;
  }
  margin-bottom: 2rem;
}

@com-color: spin(@brand-warning, -15);

@survey-types: {
  com: darken(@com-color, 15%) lighten(@com-color, 37%) @com-color;
  sheets:
    darken(@brand-success, 15%) lighten(@brand-success, 42%) @brand-success;
  doc:
    darken(@brand-warning, 15%) lighten(@brand-warning, 35%) @brand-warning;
}

each(@survey-types, .(@colors, @name) {
  @dark: extract(@colors, 1);
  @light: extract(@colors, 2);
  @active: extract(@colors, 3);

  .survey-question-@{name} {
    border-color: @dark;
    background-color: @light;
    color: @dark;

    .btn {
      border-color: @dark;
      color: @dark;
    }

    .btn-default:hover, .btn-default:hover.active {
      background-color: @dark;
    }

    .btn-default.active {
      background-color: @active;
    }
  }
})

.rating {
  margin-left: auto;
  margin-right: auto;
}

.rating-alerts {
  p {
    font-size: 105%;
  }
}

.question-reset {
  margin-top: 1rem;
}

</style>
